import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchListing, API } from "./api";
import { trackView } from "./analytics";
import PropertyLite from "./PropertyLite";
import App from "../App";

export default function PropertyDetail() {
  const { slug } = useParams();
  const { i18n } = useTranslation();
  const lang = i18n.language || "fr";
  const [listing, setListing] = useState(undefined);

  useEffect(() => {
    let active = true;
    setListing(undefined);
    fetchListing(slug).then((d) => { if (active) setListing(d); });
    if (slug) trackView(slug);
    return () => { active = false; };
  }, [slug]);

  // Localisation du contenu de l'annonce (traduit une fois côté serveur, fallback original).
  useEffect(() => {
    if (!slug || !listing || lang === "fr") return;
    let active = true;
    fetch(`${API}/i18n/listing/${slug}?lang=${encodeURIComponent(lang)}`)
      .then((r) => r.ok ? r.json() : null)
      .then((d) => {
        if (!active || !d || !d.fields) return;
        setListing((prev) => prev ? { ...prev, ...Object.fromEntries(Object.entries(d.fields).filter(([, v]) => v)) } : prev);
      })
      .catch(() => {});
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, lang, listing && listing.slug]);

  if (listing === undefined) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="property-loading">
        <div className="w-10 h-10 border-2 border-[#C19A6B] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (listing === null) {
    return (
      <div className="min-h-screen bg-[#050505] text-white flex flex-col items-center justify-center gap-4" data-testid="property-notfound">
        <p className="text-zinc-400">Ce bien n'existe pas ou n'est plus disponible.</p>
        <Link to="/biens-off-market" className="text-[#C19A6B] underline">Voir tous les biens</Link>
      </div>
    );
  }

  // Toutes les fiches utilisent le même template immersif (Saint-Maximin)
  return <App listing={listing} />;
}
